// jshint ignore: start
(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('regionService', regionservice);

    /* @ngInject */
    function regionservice($q, $http, config, $odata, $odataresource, logger, coreService, utilitiesService) {
        var service = {
            getDefaultCorporate: getDefaultCorporate,
            getDefaultModeModel: getDefaultModeModel,
            getDefaultRegion: getDefaultRegion,
            getDefaultRegionModel: getDefaultRegionModel,
            getDefaultArea: getDefaultArea,
            getDefaultAreaModel: getDefaultAreaModel,
            getDefaultSite: getDefaultSite,
            getGeoJsonObject: getGeoJsonObject,
            getLeafletTileLayer: getLeafletTileLayer,
            getMapStyleOptions: getMapStyleOptions,
            getCorporate: getCorporate,
            getCorporates: getCorporates,
            getRegions: getRegions,
            getStatesWithSites: getStatesWithSites,
            getAreas: getAreas,
            getCustomerODataResource: getCustomerODataResource,
            getRegionODataResource: getRegionODataResource,
            getAreaODataResource: getAreaODataResource,
            saveRegion: saveRegion,
            saveArea: saveArea,
            deleteRegion: deleteRegion,
            deleteArea: deleteArea
        };

        activate();

        return service;

        function activate() {
        }

        function getDefaultModeModel() {
            var model = {
                isRegion: true,
                isArea: false,
                isCreate: true,
                isEdit: false
            };
            return angular.copy(model);
        }

        function getDefaultCorporate() {
            var corporate = {
                CorporateId: 0,
                Name: ''
            };
            return corporate;
        }

        function getDefaultRegion() {
            var region = {
                CorporateId: 0,
                RegionId: 0,
                RegionName: '',
                States: []
            };
            return region;
        }

        function getDefaultRegionModel() {
            var model = {
                id: 0,
                name: '',
                corporateid: 0,
                states: []
            };
            return angular.copy(model);
        }

        function getDefaultArea() {
            var area = {
                CorporateId: 0,
                AreaId: 0,
                AreaName: '',
                Sites: []
            };
            return area;
        }

        function getLeafletTileLayer() {
            var tileLayer = {
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
                minZoom: 4,
                maxZoom: 16
            }
            return tileLayer;
        }

        function getMapStyleOptions() {
            var style = {
                color: '#000',
                weight: 0.5,
                zIndex: 1,
                fillColor: '#f9f9f9',
                fillOpacity: 0.2
            };
            return style;
        }

        function getDefaultAreaModel() {
            var model = {
                id: 0,
                name: '',
                corporateid: 0,
                states: [],
                selectedSites: 0,
                totalSites: 0
            };
            return angular.copy(model);
        }

        function getDefaultSite() {
            return {
                CorporateId: 0,
                StateId: 0,
                SiteIds: []
            };
        }

        function getCustomerODataResource() {
            return $odataresource(config.sharedDataApiUrl + '/odata/Customer',
                {},
                {},
                {
                    odatakey: 'CustomerId',
                    isodatav4: true
                });
        }

        function getRegionODataResource() {
            return $odataresource(config.sharedDataApiUrl + '/odata/Region',
                {},
                {},
                {
                    odatakey: 'RegionId',
                    isodatav4: true
                });
        }

        function getAreaODataResource() {
            return $odataresource(config.sharedDataApiUrl + '/odata/Area',
                {},
                {},
                {
                    odatakey: 'AreaId',
                    isodatav4: true
                });
        }

        function getGeoJsonObject() {
            return $http.get('/Content/src/client/app/services/data/map-min.json');
        }

        function getCorporate(corporateId) {
            var customer = getCustomerODataResource();
            var query = customer.odata();

            return query
                .filter('CustomerID', corporateId)
                .filter('Deleted', false)
                .select('CustomerID', 'CustomerDisplayName')
                .query()
                .$promise
                .then(function (result) {
                    var corporates = [];
                    if (result.length) {
                        var currentCorporate = {
                            id: result[0].CustomerID,
                            name: result[0].CustomerDisplayName
                        }
                        corporates.push(currentCorporate);
                    }
                    return corporates;
                });
        }

        function getCorporates() {
            return coreService.httpGet(config.sharedDataApiUrl, 'api/Corporate/TopLevel').then(function (result) {
                var corporates = [];
                angular.forEach(result.data, function (corporate) {
                    var currentCorporate = {
                        id: corporate.CustomerId,
                        name: corporate.CustomerName
                    }
                    corporates.push(currentCorporate);
                });
                return corporates;
            });
        }

        function getRegions(corporateId, user) {
            if (!(user.isInRole('SSO:SysAdmin') || user.isInRole('SSO:Corp:Admin') || user.isInRole('SSO:Reg:Admin'))) {
                return $q.when({});
            }

            var region = getRegionODataResource();
            var query = region.odata();

            query = query.filter('CorporateCustomerId', corporateId);

            if (user.isInRole('SSO:Reg:Admin')) {
                query = query.filter('RegionId', user.userSettings.RegionId);
            }

            return query.filter('Deleted', false)
                .select('CorporateCustomerId', 'RegionId', 'RegionName')
                .expandPredicate('RegionStateTie')
                .select('State')
                .expandPredicate('State')
                .select('StateId')
                .select('StateName')
                .select('StateCode')
                .finish()
                .finish()
                .query()
                .$promise
                .then(function (result) {
                    var regions = [];
                    angular.forEach(result, function (region) {
                        var newRegion = {};
                        newRegion.id = region.RegionId;
                        newRegion.name = region.RegionName;
                        newRegion.corporateid = region.CorporateCustomerId;
                        newRegion.states = [];
                        angular.forEach(region.RegionStateTie, function (tie) {
                            newRegion.states.push({
                                id: tie.State.StateId,
                                name: tie.State.StateName
                            });
                        });
                        regions.push(newRegion);
                    });
                    return regions;
                });
        }

        function getStatesWithSites(corporateId) {
            return coreService.httpGet(config.sharedDataApiUrl, 'api/Corporate/' + corporateId + '/StatesWithSites');
        }

        function getAreas(corporateId, user) {

            if (!(user.isInRole('SSO:SysAdmin') || user.isInRole('SSO:Corp:Admin') || user.isInRole('SSO:Area:Admin'))) {
                return $q.when({});
            }

            var area = getAreaODataResource();
            var query = area.odata();

            query = query.filter('CorporateCustomerId', corporateId);

            if (user.isInRole('SSO:Area:Admin')) {
                query = query.filter('AreaId', user.userSettings.AreaId);
            }

            query = query.filter('Deleted', false)
                .select('CorporateCustomerId', 'AreaId', 'AreaName')
                .expandPredicate('AreaCustomerSiteTies')
                .select('Customer')
                .filter('Customer/MostPurchasedTruckSeries', '!=', new $odata.Property('null'))
                .filter('Customer/Deleted', false)
                .expandPredicate('Customer')
                .select('CustomerID')
                .select('CustomerDisplayName')
                .select('StateId')
                .select('Address1')
                .select('Address2')
                .select('Latitude')
                .select('Longitude')
                .select('TruckSeries')
                .expandPredicate('TruckSeries')
                .select('ActiveTruckIconUrl')
                .select('InactiveTruckIconUrl')
                .finish()
                .expandPredicate('State')
                .select('StateName')
                .finish()
                .finish()
                .finish()
                .query();

            return query
                .$promise
                .then(function (result) {
                    var areas = [];
                    var selectedSites = 0;
                    angular.forEach(result, function (area) {
                        var newArea = {};
                        newArea.id = area.AreaId;
                        newArea.name = area.AreaName;
                        newArea.corporateid = area.CorporateCustomerId;
                        newArea.states = [];
                        angular.forEach(area.AreaCustomerSiteTies, function (tie) {
                            var index = utilitiesService.getIndexOf(newArea.states, 'id', tie.Customer.StateId);
                            var displayName = tie.Customer.CustomerDisplayName.split('-');
                            var currentSite = {
                                id: tie.Customer.CustomerID,
                                name: displayName[0],
                                address: displayName[1],
                                city: displayName[2],
                                latitude: tie.Customer.Latitude,
                                longitude: tie.Customer.Longitude
                            };
                            if (index !== -1) {
                                newArea.states[index].sites.push(currentSite);
                            } else {
                                newArea.states.push({
                                    id: tie.Customer.StateId,
                                    name: tie.Customer.State.StateName,
                                    sites: [currentSite]
                                });
                            }
                            selectedSites++;
                        });
                        newArea.selectedSites = selectedSites;
                        newArea.totalSites = 0;
                        areas.push(newArea);
                    });
                    return areas;
                });
        }
        
        function saveRegion(region) {
            return coreService.httpPost(config.sharedDataApiUrl, 'api/RegionManagement', convertToDto(region, false));
        }

        function saveArea(area) {
            return coreService.httpPost(config.sharedDataApiUrl, 'api/AreaManagement', convertToDto(area, true));
        }

        function deleteRegion(region) {
            return coreService.httpPost(config.sharedDataApiUrl, 'api/RegionManagement/' + region.id, convertToDto(region, false));
        }

        function deleteArea(area) {
            return coreService.httpPost(config.sharedDataApiUrl, 'api/AreaManagement/' + area.id, convertToDto(area, true));
        }

        function convertToDto(object, isArea) {
            var data;

            if (!isArea) {
                data = {
                    CorporateId: object.corporateid,
                    RegionId: object.id,
                    RegionName: object.name,
                    StateIds: []
                };

                angular.forEach(object.states,
                    function (state) {
                        data.StateIds.push(state.id);
                    });

                return data;
            }

            data = {
                CorporateId: object.corporateid,
                AreaId: object.id,
                AreaName: object.name,
                SiteIds: []
            };

            angular.forEach(object.states, function (state) {
                angular.forEach(state.sites, function (site) {
                    data.SiteIds.push(site.id);
                });
            });

            return data;
        }
    }
})();
